export const API_CONFIG = {
  baseURL: process.env.BE_API_URL || 'http://localhost:5251'
};